import { formatDate } from 'utils/FormatDate'

export const dateCellTemplate = (props) => (
    <div className='text-center'>{formatDate(props.getValue(), 'd/m/Y') || '-'}</div>
)
